import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const modalProps = {
  isBlocking: true,
  className: 'cancel-brand-list-dialog',
};

export const CancelDialog = (props) => {
  const { open, onConfirm, onDismiss } = props;
  const i18n = useContext(I18nContext);

  const dialogContentProps = {
    type: DialogType.normal,
    title: i18n.getString(_TL_('Cancel brand list creation')),
    closeButtonAriaLabel: i18n.getString(_TL_('Close')),
    subText: i18n.getString(_TL_('Your brand list will be deleted along with all the brands you\'ve added and requested will be removed. Are you sure you want to cancel your brand list creation?')),
  };

  return (
    <Dialog
      hidden={!open}
      onDismiss={onDismiss}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      minWidth={480}
    >
      <DialogFooter>
        <DefaultButton className="confirm-button" onClick={onConfirm} text={i18n.getString(_TL_('Yes'))} />
        <PrimaryButton className="cancel-button" onClick={onDismiss} text={i18n.getString(_TL_('No'))} />
      </DialogFooter>
    </Dialog>
  );
};

CancelDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};
